import * as React from "react";
import Chart from 'react-google-charts'

class MultiLineChart extends React.Component {
  constructor(props) {
    super(props);

    let lineChartOptions = {
      hAxis: {
        title: props.hAxisTitle,
      },
      vAxis: {
        title: props.vAxisTitle,
        format: 'currency'
      },
      series: {
        1: { curveType: 'function' },
      },
    }
    
    this.state = {
        key: props.key,
        lineData: props.chartData,
        chartOpen: false,
        lineChartOptions
    };
  }

  render() {
    return (
      <div className="container mt-5"  style={{ marginTop: 50}}>
        <Chart
          width={'100%'}
          height={'500px'}
          chartType="LineChart"
          loader={<div>Loading Chart</div>}
          data={this.state.lineData}
          options={this.state.lineChartOptions}
        />
      </div>
    )
  }
}
export default MultiLineChart